// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.reset-password-container,
.forgot-password-container {
  max-width: 500px;
  margin: 50px auto;
}
.one-column-form {
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
}

.card-subtitle {
  color: #333;
  margin-bottom: var(--spacing-xs);
}
.white-form .input-field[type="text"],
.white-form .input-field[type="password"],
.white-form .input-field[type="email"]{
  background: #fff !important;
  font-size: 16px !important;
  padding: 10px 12px !important;
  color: #000 !important;
  border: 1px solid #333;
  font-family: var(--font-family);
}
.white-form .input-label {
  color: #333 !important;
}
.btn-primary {
  background: var(--proskins-green) !important;
  margin: 1rem 0 0.75rem 0 !important;
}`, "",{"version":3,"sources":["webpack://./src/pages/ResetPassword.css"],"names":[],"mappings":"AAAA;;EAEE,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,WAAW;EACX,gCAAgC;AAClC;AACA;;;EAGE,2BAA2B;EAC3B,0BAA0B;EAC1B,6BAA6B;EAC7B,sBAAsB;EACtB,sBAAsB;EACtB,+BAA+B;AACjC;AACA;EACE,sBAAsB;AACxB;AACA;EACE,4CAA4C;EAC5C,mCAAmC;AACrC","sourcesContent":[".reset-password-container,\n.forgot-password-container {\n  max-width: 500px;\n  margin: 50px auto;\n}\n.one-column-form {\n  display: flex;\n  flex-direction: column;\n  gap: 1.5rem;\n}\n\n.card-subtitle {\n  color: #333;\n  margin-bottom: var(--spacing-xs);\n}\n.white-form .input-field[type=\"text\"],\n.white-form .input-field[type=\"password\"],\n.white-form .input-field[type=\"email\"]{\n  background: #fff !important;\n  font-size: 16px !important;\n  padding: 10px 12px !important;\n  color: #000 !important;\n  border: 1px solid #333;\n  font-family: var(--font-family);\n}\n.white-form .input-label {\n  color: #333 !important;\n}\n.btn-primary {\n  background: var(--proskins-green) !important;\n  margin: 1rem 0 0.75rem 0 !important;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
